import { render, staticRenderFns } from "./SideBarNavItem.vue?vue&type=template&id=111fc046&scoped=true"
import script from "./SideBarNavItem.vue?vue&type=script&lang=js"
export * from "./SideBarNavItem.vue?vue&type=script&lang=js"
import style0 from "@/assets/bootstrap5/sidebars.css?vue&type=style&index=0&id=111fc046&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111fc046",
  null
  
)

export default component.exports